import { IS_SIDEBAR_COLLAPSED_KEY } from '@/App';

const getters = {
  setting: state => key => state[key],

  isSidebarCollapsed: state => state[IS_SIDEBAR_COLLAPSED_KEY],
};

export default getters;
